import React from 'react';
import { Alert, Typography } from 'amphitheatre';
import { GiRingedPlanet } from 'react-icons/gi';

import { Card, TutText, TutorialTag } from '../Tutorials.styled';
import TutorialPage from '../TutorialPage';
import ImagePopup from '../../../ImagePopup';

import Pic1 from './pic1.png';
import Pic2 from './pic2.png';

const { Paragraph } = Typography;

const Step5: React.FunctionComponent = () => {
  return (
    <TutorialPage nobg title="Tutorial #5: How to save a scene">
      <Card>
        <TutorialTag>
          <GiRingedPlanet />
          STEP 1
        </TutorialTag>
        <ImagePopup src={Pic1} alt="main menu" />
        <TutText>
          <Paragraph>
            A PIGI save scene must be included in your submission. To do this,
            click the scene button on the menu wheel.
          </Paragraph>
        </TutText>
      </Card>
      <Card>
        <TutorialTag>
          <GiRingedPlanet /> STEP 2
        </TutorialTag>
        <ImagePopup src={Pic2} alt="controls" />
        <TutText>
          <Paragraph>
            This will bring up a dialog box, name your scene and click save.
            Your scene file should appear in the greyed out area above the input
            box, in our example pigi_test.json is now saved.
          </Paragraph>
          <Paragraph>
            In order to access your saved scene file, search in:
          </Paragraph>
          <Paragraph style={{ wordWrap: 'break-word', fontStyle: 'italic' }}>
            C:\Users\(account)\AppData\LocalLow\SaberAstronautics\PIGI\SaveData
          </Paragraph>
          <Paragraph>The save file will be in .JSON format.</Paragraph>
          <Paragraph>
            <Alert warning>
              Please note: in order to find the ‘AppData’ folder, you must allow
              hidden files / folders to be shown.
              <a href="https://support.microsoft.com/en-gb/help/14201/windows-show-hidden-files">
                How to do it.
              </a>
            </Alert>
          </Paragraph>
        </TutText>
      </Card>
    </TutorialPage>
  );
};

export default Step5;
